import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { FormWrapper } from './Wrappers';
import { Customer, genericMemo } from './Types';

export function isValidCustomer(customerId: string | null) {
  return customerId !== null
}

function CustomerSelectRaw({customers, value, onChange, error, ...props}: {
    customers: Customer[],
    value: string | null,
    onChange: (newValue: string | null) => void,
    error: boolean
} ) {

  type Option = {
    value: string,
    label: string
  }
  const options: Option[] = customers.map(
    customer => ({value: customer.Id, label: `${customer.Name} (${customer.EmailAddress}, ${customer.CustomerNumber})`})
  )
  const selectedOptionOrUndefined = options.find(option => option.value == value)
  const selectedOption = selectedOptionOrUndefined === undefined ? null : selectedOptionOrUndefined

  function handleChange(option: Option | null) {
      const newCustomerId = option === null ? null : option.value
      onChange(newCustomerId)
  }

  return (
    <Autocomplete
      {...props}
      value={selectedOption}
      onChange={(_event, newValue) => {
        handleChange(newValue)
      }}
      options={options}
      autoHighlight
      renderInput={(params) => <TextField {...params} error={error}/>}
    />
  )
}

const CustomerSelect = genericMemo(FormWrapper({Component: CustomerSelectRaw, validationFunction: isValidCustomer}))

export default CustomerSelect
